import React, { useRef } from 'react';

// A <form> that never emits a native "submit" event (so third-party generic
// form-submit listeners such as GTM's cannot observe it) but keeps HTML5 validation.
// Mark the action button with type="button" and data-submit.
export const SafeForm = ({ onValidSubmit, children, ...props }) => {
  const ref = useRef(null);
  const run = () => { if (ref.current && ref.current.reportValidity()) onValidSubmit(); };
  const onKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); run(); }
  };
  const onClick = (e) => {
    const btn = e.target.closest && e.target.closest('button[data-submit]');
    if (btn && ref.current && ref.current.contains(btn) && !btn.disabled) { e.preventDefault(); run(); }
  };
  return (
    <form ref={ref} {...props} onSubmit={(e) => e.preventDefault()} onKeyDown={onKeyDown} onClick={onClick}>
      {children}
    </form>
  );
};
